import { MapPin, Navigation } from "lucide-react";
import { Reveal } from "./Reveal";
import { COMPANY } from "@/data/content";

const MAPS_QUERY = encodeURIComponent(COMPANY.address);
const EMBED_SRC = `https://maps.google.com/maps?q=${MAPS_QUERY}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
const DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`;

// Google Maps card with the business address (light theme)
export default function MapCard({ cityName }) {
  return (
    <section data-testid="map-card" className="py-20 md:py-28 bg-brand-mist">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-[1fr_1.4fr] gap-10 items-stretch">
        <Reveal className="flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-golddark">
            <span className="w-8 h-px bg-brand-gold" /> Nous trouver
          </span>
          <h2 className="mt-5 font-display font-semibold text-4xl md:text-5xl tracking-tight text-brand-navy leading-[1.05]">
            {cityName ? `À deux pas de ${cityName}` : "Notre adresse"}
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-md">
            Serrurier de proximité basé à Lagny-sur-Marne, nous rayonnons dans
            tout le secteur de Marne-la-Vallée pour vous dépanner rapidement.
          </p>
          <div className="mt-8 flex items-start gap-3 text-brand-navy">
            <MapPin className="w-5 h-5 text-brand-gold shrink-0 mt-1" />
            <span className="text-lg font-medium">{COMPANY.address}</span>
          </div>
          <a
            href={DIRECTIONS}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="directions-btn"
            className="mt-8 inline-flex items-center gap-2 bg-brand-navy hover:bg-brand-navy2 text-white px-7 py-4 rounded-full font-semibold text-base transition-colors duration-300 w-fit"
          >
            <Navigation className="w-4 h-4" /> Itinéraire
          </a>
        </Reveal>

        <Reveal delay={0.1} className="min-h-[380px]">
          <div className="h-full min-h-[380px] rounded-2xl border border-brand-line overflow-hidden shadow-xl shadow-brand-navy/5">
            <iframe
              title={`Localisation ${COMPANY.name}`}
              src={EMBED_SRC}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 380 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
